import axios from "axios";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import baseURL from "../../../configs/api";
import TimeInput from "../../../components/common/TimeInput";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../components/hooks/useGeneral";
import { useTheme } from "../../../components/hooks/useTheme";
import useDelete from "../../../components/hooks/useDelete";
import colorConfigs from "../../../configs/colorConfigs";
import useAuth from "../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import moment from "moment";

export const BlockedDays = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();

  const [label, setLabel] = useState<string>("");
  const [color, setColor] = useState<string>("#000000");
  const [startDate, setStartDate] = useState<string>("");
  const [startTime, setStartTime] = useState<string>("");
  const [endTime, setEndTime] = useState<string>("");
  const [isAllDay, setIsAllDay] = useState<boolean>(false);
  const [isRepeat, setIsRepeat] = useState<boolean>(false);
  const [timeSlot, setTimeSlot] = useState<string>("09-10");
  const [endRepeat, setEndRepeat] = useState<string>("After");
  const [tableData, setTableData] = useState<any[]>([]);
  const [previewRow, setPreviewRow] = useState<boolean>(false);
  const [isChanged, setIsChanged] = useState<boolean>(true);
  const [deleteItem, setDeleteItem] = useState<string[]>([]);
  const [deleteAllItem, setAllDeleteItem] = useState<boolean>(false);
  const [firstTime, setFirstTime] = useState<boolean>(true);
  const [id, setId] = useState<string>("");
  const [repeatOccur, setRepeatOccur] = useState<string>("Every Year");
  const [afterOccurrences, setAfterOccurrences] = useState<string>("");
  const [ondate, setOndate] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(true);

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setPleaseWaitPopup(true);

    if (id) {
      await axios
        .put(
          `${baseURL}blockedDay?userId=${auth?.id}`,
          JSON.stringify({
            id,
            name: label,
            color,
            startDate,
            isAllDay,
            timeSlot: isAllDay ? "" : timeSlot,
            startTime: isAllDay ? "" : startTime,
            endTIme: isAllDay ? "" : endTime,
            repeat: isRepeat,
            repeatOccur: isRepeat ? repeatOccur : "",
            endrepeat: endRepeat,
            afterOccurrences: isRepeat ? afterOccurrences : "",
            ondate: isRepeat ? ondate : "",
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setId("");
          setLabel("");
          setColor("#000000");
          setStartDate("");
          setStartTime("");
          setEndTime("");
          setIsAllDay(false);
          setIsRepeat(false);
          setTimeSlot("");
          setRepeatOccur("Every Year");
          setEndRepeat("");
          setAfterOccurrences("After");
          setOndate("");
          setIsChanged(true);
          setAllDeleteItem(false);
          setPreviewRow(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      await axios
        .post(
          `${baseURL}blockedDay?userId=${auth?.id}`,
          JSON.stringify({
            name: label,
            color,
            startDate,
            isAllDay,
            timeSlot: isAllDay ? "" : timeSlot,
            startTime: isAllDay ? "" : startTime,
            endTIme: isAllDay ? "" : endTime,
            repeat: isRepeat,
            repeatOccur: repeatOccur,
            endrepeat: endRepeat,
            afterOccurrences: isRepeat ? afterOccurrences : "",
            ondate: isRepeat ? ondate : "",
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setLabel("");
          setColor("#000000");
          setStartDate("");
          setStartTime("");
          setEndTime("");
          setIsAllDay(false);
          setIsRepeat(false);
          setTimeSlot("");
          setRepeatOccur("Every Year");
          setEndRepeat("");
          setAfterOccurrences("After");
          setOndate("");
          setIsChanged(true);
          setAllDeleteItem(false);
          setPreviewRow(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  useEffect(() => {
    if (isChanged) {
      axios
        .get(`${baseURL}blockedDay`, {
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
        .then((response) => {
          setTableData(() => response.data);
          setIsChanged(false);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setIsChanged(false);
          setPleaseWaitPopup(false);
          console.error("Error:", error);
          handleTenantError(error);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChanged]);

  useEffect(() => {
    if (!firstTime) {
      if (!deleteAllItem) {
        setDeleteItem([]);
      } else {
        setDeleteItem(() =>
          tableData.map((item: any) => {
            return item.id;
          })
        );
      }
    }

    setFirstTime(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAllItem]);

  const deleteSelectedItem = async () => {
    setDeleteData({
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Blocked Day?`,
      isDelete: (callback: any) => {
        Promise.all(
          deleteItem?.map((item: string) =>
            axios.delete(`${baseURL}blockedDay?id=${item}&userId=${auth?.id}`, {
              headers: {
                'X-Tenant-ID': tenantId,
              }
            })
          )
        )
          .then(() => {
            setIsChanged(true);
            setAllDeleteItem(false);
            setPleaseWaitPopup(true);
            setDeleteItem([]);
            handleTenantError(null);
          })
          .catch((error) => {
            setIsChanged(true);
            setAllDeleteItem(false);
            setPleaseWaitPopup(true);
            handleTenantError(error);
          });

        callback();
      }
    });

    setDeletePopup(true);
  };

  const editTheData = (primaryKey: string) => {
    setId(primaryKey);

    axios
      .get(`${baseURL}blockedDay/${primaryKey}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setLabel(response.data.name);
        setColor(response.data.color);
        setStartDate(response.data?.startDate?.split("T")[0]);
        setIsAllDay(response.data.isAllDay);
        setTimeSlot(response.data.timeSlot);
        setStartTime(response.data.startTime);
        setEndTime(response.data.endTIme);
        setIsRepeat(response.data.repeat);
        setEndRepeat(response.data.endRepeat);
        setRepeatOccur(response.data.repeatOccur);
        setAfterOccurrences(response.data.afterOccurrences);
        setOndate(response.data?.ondate?.split("T")[0]);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
  };

  const onCancel = () => {
    setId("");
    setLabel("");
    setColor("#000000");
    setStartDate("");
    setStartTime("");
    setEndTime("");
    setIsAllDay(false);
    setIsRepeat(false);
    setTimeSlot("");
    setRepeatOccur("Every Year");
    setEndRepeat("");
    setAfterOccurrences("After");
    setOndate("");
    setAllDeleteItem(false);
  };


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className={`p-2.5 ${themeStyles.main.textHeadingColor}`}>Blocked Days</div>

          <hr />

          <div className={`w-full flex flex-row pt-2.5 px-2 ${themeStyles.main.borderColor}`}>
            <div className={`w-2/5 mr-3 ${themeStyles.main.borderColor}`}>
              <h2 className={`text-sm m-0 ${themeStyles.main.textHeadingColor}`}>
                {id ? "Edit" : "Add New"} Scheduling
              </h2>

              <hr />

              <form onSubmit={(e) => handleFormSubmit(e)} className="w-full grid grid-cols-2 gap-x-[2rem] gap-y-4 mt-2">
                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    required
                  />
                </div>

                <div className="flex flex-col">
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Color</label>
                  <input
                    type="color"
                    name="color"
                    style={{
                      fontSize: "14px",
                    }}
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                  />
                </div>

                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Date</label>
                  <CustomFormatDatePicker
                    value={startDate}
                    onChange={setStartDate}
                    dateFormat={dateFormat}
                    required={true}
                  />
                </div>

                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>All Day?</label>
                  <RadioGroup
                    row
                    value={isAllDay}
                    onChange={(e) => setIsAllDay(e.target.value === "true")}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "blue",
                            },
                          }}
                        />
                      }
                      label="Yes"
                      sx={{
                        color: themeStyles.form.labelTextColor,
                      }}
                    />

                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "blue",
                            },
                          }}
                        />
                      }
                      label="No"
                      sx={{
                        color: themeStyles.form.labelTextColor,
                      }}
                    />
                  </RadioGroup>
                </div>

                {
                  !isAllDay
                  && (
                    <>
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Time Slot</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={timeSlot}
                          onChange={(e) => setTimeSlot(e.target.value)}
                        >
                          <option value="09-10">09-10</option>
                          <option value="10-11">10-11</option>
                          <option value="11-12">11-12</option>
                          <option value="12-13">12-13</option>
                          <option value="13-14">13-14</option>
                          <option value="14-15">14-15</option>
                          <option value="15-16">15-16</option>
                          <option value="16-17">16-17</option>
                          <option value="17-18">17-18</option>
                          <option value="18-19">18-19</option>
                          <option value="19-20">19-20</option>
                        </select>
                      </div>

                      <div />

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Time</label>
                        <TimeInput
                          name={"startTime"}
                          value={startTime}
                          setValue={setStartTime}
                          required={true}
                        />
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>End Time</label>
                        <TimeInput
                          name={"endTime"}
                          value={endTime}
                          setValue={setEndTime}
                          required={true}
                        />
                      </div>
                    </>
                  )
                }

                <div className="col-span-2">
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repeat?</label>
                  <RadioGroup
                    row
                    value={isRepeat}
                    onChange={(e) => setIsRepeat(e.target.value === "true")}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "blue",
                            },
                          }}
                        />
                      }
                      label="Yes"
                      sx={{
                        color: themeStyles.form.labelTextColor,
                      }}
                    />

                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "blue",
                            },
                          }}
                        />
                      }
                      label="No"
                      sx={{
                        color: themeStyles.form.labelTextColor,
                      }}
                    />
                  </RadioGroup>
                </div>

                {
                  isRepeat
                  && (
                    <>
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repeats</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={repeatOccur}
                          onChange={(e) => setRepeatOccur(e.target.value)}
                        >
                          <option value="Every Year">Every Year</option>
                          <option value="Every Month">Every Month</option>
                          <option value="Every Week">Every Week</option>
                          <option value="Every Day">Every Day</option>
                        </select>
                      </div>

                      <div />

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>End Repeat</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={endRepeat}
                          onChange={(e) => setEndRepeat(e.target.value)}
                        >
                          <option value="After">After</option>
                          <option value="On Date">On Date</option>
                        </select>
                      </div>

                      {
                        endRepeat === "After"
                          ? (
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>After Occurrences</label>
                              <input
                                type="text"
                                className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={afterOccurrences}
                                onChange={(e) => setAfterOccurrences(e.target.value)}
                                required
                              />
                            </div>
                          ) : (
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>On Dates</label>
                              <CustomFormatDatePicker
                                value={ondate}
                                onChange={setOndate}
                                dateFormat={dateFormat}

                              />
                            </div>
                          )
                      }
                    </>
                  )
                }

                <div className="col-span-2 mt-2">
                  {
                    id
                      ? (
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color,
                            marginRight: "10px"
                          }}
                          onClick={() => onCancel()}
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg,
                            marginRight: "10px"
                          }}
                          onClick={() => setPreviewRow(!previewRow)}
                        >
                          Preview
                        </Button>
                      )
                  }

                  <Button variant="contained"
                    sx={{
                      backgroundColor: colorConfigs.btn.main.bg
                    }}
                    type="submit"
                  >
                    {id ? "Update" : "Save"}
                  </Button>
                </div>
              </form>
            </div>

            <div className="w-3/5 px-2">
              <div>
                <div className="flex justify-between items-center">
                  <h2 className={`text-sm m-0 ${themeStyles.main.textHeadingColor}`}>
                    Blocked Dates
                  </h2>

                  <Button variant="contained"
                    sx={{
                      backgroundColor: colorConfigs.btn.delete.bg,
                      marginBottom: "5px",
                      padding: "7px",
                      fontSize: "11px"
                    }}
                    onClick={deleteSelectedItem}
                    disabled={!deleteItem?.length}
                  >
                    Delete Selected
                  </Button>
                </div>

                <hr />

                <table className="min-w-full border border-collapse text-xs">
                  <thead className={`${themeStyles.table.headerBg}`}>
                    <tr>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>
                        <input
                          type="checkbox"
                          checked={deleteAllItem}
                          onChange={() => setAllDeleteItem(() => !deleteAllItem)}
                        />
                      </th>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>Label</th>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>Color</th>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>Starts At</th>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>Ends At</th>
                      <th className={`p-2 text-left ${themeStyles.table.tailwindHeaderColor} border`}>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      tableData?.map((item: any) => {
                        return (
                          <tr key={item.id} className="border">
                            <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>
                              <input
                                type="checkbox"
                                checked={deleteItem.includes(item.id)}
                                onChange={() => {
                                  const updated = deleteItem.includes(item.id)
                                    ? deleteItem.filter((id: string) => id !== item.id)
                                    : [...deleteItem, item.id];
                                  setDeleteItem(updated);
                                }}
                              />
                            </td>

                            <td
                              className={`p-2 border cursor-pointer hover:underline`}
                              style={{ color: "var(--app-link-color)" }}
                              onClick={() => editTheData(item?.id)}
                            >
                              {item.name}
                            </td>

                            <td className="p-2 border">
                              <div className="rounded" style={{ backgroundColor: item.color, padding: "10px 8px" }} />
                            </td>

                            <td
                              className={`p-2 border ${themeStyles.table.tailwindTextColor}`}
                            >
                              {item?.startDate
                                ? moment(
                                  `${item.startDate.split("T")[0]} ${item.startTime || "00:00"}`
                                ).format(dateFormat + " hh:mm a")
                                : ""}
                            </td>

                            <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>
                              {item?.startDate
                                ? moment(
                                  `${item.startDate.split("T")[0]} ${item.endTIme || "00:00"}`
                                ).format(dateFormat + " hh:mm a")
                                : ""}
                            </td>

                            <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>Closed</td>
                          </tr>
                        )
                      })
                    }

                    {
                      previewRow && (
                        <tr className="border">
                          <td className="p-2 border">
                            <input type="checkbox" />
                          </td>

                          <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>{label}</td>

                          <td className="p-2 border">
                            <div className="rounded" style={{ backgroundColor: color, padding: "10px 8px" }} />
                          </td>

                          <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>
                            {
                              startTime &&
                              moment(new Date(startDate + "T" + startTime)).format(
                                dateFormat + " hh:mm a"
                              )
                            }
                          </td>

                          <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>
                            {
                              endTime &&
                              moment(new Date(startDate + "T" + endTime)).format(
                                dateFormat + " hh:mm a"
                              )
                            }
                          </td>

                          <td className={`p-2 border ${themeStyles.table.tailwindTextColor}`}>Closed</td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
};
